import { Component, Input, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'
import { LabelToId } from 'src/app/common/input-utils'
import { Datum } from 'src/app/models/common/datum'

// Multi-select pill/chip picker (DESIGN.md "Chip" spec) — real <button aria-pressed> toggles
// inside a role="group" container (not role="radiogroup"/aria-checked: EXPERIENCE.md's Interaction
// Primitives draws an explicit line between a toggle control like this, where any number of chips
// can be selected independently of each other, and TileGroupComponent's/PillChoiceComponent's
// single-select radio pattern). First real consumer: story e8-3's NdisClassificationStepComponent.
@Component({
  selector: 'app-chip-group',
  templateUrl: './chip-group.component.html',
  styleUrls: ['./chip-group.component.scss'],
  standalone: false,
})
export class ChipGroupComponent implements OnInit {
  @Input() control: FormControl
  @Input() options: Datum[] = []
  @Input() label: string
  @Input() required: boolean = false
  @Input() errorText: string

  id: string
  errorId: string

  ngOnInit(): void {
    this.id = LabelToId(this.label)
    this.errorId = `${this.id}-error`
  }

  get isInvalid(): boolean {
    return (
      this.required &&
      this.control?.invalid === true &&
      this.control?.touched === true
    )
  }

  isSelected(value: string): boolean {
    return ((this.control?.value as string[] | null) ?? []).includes(value)
  }

  toggleOption(value: string): void {
    if (!this.control) {
      return
    }
    const current = (this.control.value as string[] | null) ?? []
    const next = current.includes(value)
      ? current.filter((existing) => existing !== value)
      : [...current, value]
    this.control.setValue(next)
    this.control.markAsTouched()
  }
}
